module.exports = __webpack_public_path__ + "static/media/manchesr_united.3cb0cfe2.png";